import { useCallback, useEffect } from 'preact/hooks';

export const useTouchMove = (element) => {
  const handleTouchMove = useCallback(
    (event) => {
      const isScrollable =
        element?.scrollWidth > element?.clientWidth ||
        element?.scrollHeight > element?.clientHeight;

      if (!isScrollable) {
        event.preventDefault();
      }
    },
    [element],
  );

  useEffect(() => {
    element?.addEventListener('touchmove', handleTouchMove);

    return () => {
      element?.removeEventListener('touchmove', handleTouchMove);
    };
  }, [element, handleTouchMove]);
};
